export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    }
  },
  methods: {
    closeModal() {
      this.$emit('cancel');
    }
  }
};
